/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorFallbackComponent = ({ error, resetErrorBoundary }) => {
  const navigate = useNavigate();

  const onClickBack = () => {
    resetErrorBoundary();
    navigate('/home')
  }
  return (<>
    <section className="py-3 py-md-5 min-vh-100 d-flex justify-content-center align-items-center">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="text-center">
              <h2 className="d-flex justify-content-center align-items-center gap-2 mb-4">
                <span className="display-1 font-weight-bolder">5</span>
                <span className="display-1 font-weight-bolder">0</span>
                <span className="display-1 font-weight-bolder bsb-flip-h">0</span>
              </h2>
              <h3 className="h2 mb-2">Something went wrong:</h3>
              <p className="mb-5">{error.message}</p>
              <a className="btn bsb-btn-5xl btn-dark rounded-pill px-5 fs-6 m-0" role="button" onClick={onClickBack}>Back to Home</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div> */}
  </>);
}

export default ErrorFallbackComponent;